/**
 * @name Lines
 * @description Componente común de líneas de colores de Talentry
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Lines = (props) => {
  const { direction } = props;

  return (
    <>
      {direction === 'horizontal' && (
        <Styled.HorizontalLine>
          <Styled.FirstLine {...props} />
          <Styled.Intersection />
          <Styled.SecondLine {...props} />
        </Styled.HorizontalLine>
      )}
      {direction === 'vertical' && (
        <Styled.VerticalLine>
          <Styled.FirstLine {...props} />
          <Styled.Intersection />
          <Styled.SecondLine {...props} />
        </Styled.VerticalLine>
      )}
    </>
  );
};

Lines.propTypes = {
  // Dirección de la línea.
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  // FirstLine propiedades de tamaño y color.
  firstLine: PropTypes.exact({
    size: PropTypes.number,
    color: PropTypes.string
  }),
  // SecondLine propiedades de tamaño y color.
  secondLine: PropTypes.exact({
    size: PropTypes.number,
    color: PropTypes.string
  }),
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.Line = styled.div`
  display: flex;
  z-index: 1;
`;

Styled.HorizontalLine = styled(Styled.Line)`
  position: relative;
  height: 4px;
`;

Styled.VerticalLine = styled(Styled.Line)`
  flex-direction: column;
  width: 4px;
  float: right;
`;

Styled.FirstLine = styled(Styled.Line)`
  height: ${(props) => props.direction === 'vertical' ? props.firstLine.size : 100}%;
  width: ${(props) => props.direction === 'horizontal' ? props.firstLine.size : 100}%;
  margin-right: ${(props) => props.direction === 'horizontal' ? '-2px' : 0};
  margin-bottom: ${(props) => props.direction === 'vertical' ? '-2px' : 0};
  background-color: ${(props) => props.theme.colors[props.firstLine.color]};
`;

Styled.SecondLine = styled(Styled.Line)`
  height: ${(props) => props.direction === 'vertical' ? props.secondLine.size : 100}%;
  width: ${(props) => props.direction === 'horizontal' ? props.secondLine.size : 100}%;
  margin-left: ${(props) => props.direction === 'horizontal' ? '-2px' : 0};
  margin-top: ${(props) => props.direction === 'vertical' ? '-2px' : 0};
  background-color: ${(props) => props.theme.colors[props.secondLine.color]};
`;

Styled.Intersection = styled(Styled.Line)`
  display: inline-block;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  z-index: 2;
  background-color: ${(props) => props.theme.colors.black};
`;

export default Lines;
